import X from "lucide-solid/icons/x";
import { createEffect, createUniqueId } from "solid-js";

export function Modal(props) {
  let ref;

  const titleId = createUniqueId();

  createEffect(() => {
    if (props.open) ref.showModal();
    else ref.close();
  });

  return (
    <dialog
      ref={ref}
      class="modal modal-bottom sm:modal-middle"
      aria-labelledby={titleId}
      onClose={() => props.onClose()}
    >
      <div class="modal-box relative">
        <form method="dialog">
          <button
            class="btn btn-sm btn-circle btn-ghost absolute right-2 top-2"
            aria-label="Close"
          >
            <X />
          </button>
        </form>
        <h3 id={titleId} class="text-lg font-bold">
          {props.title}
        </h3>
        {props.children}
      </div>
      <form method="dialog" class="modal-backdrop">
        <button>close</button>
      </form>
    </dialog>
  );
}
